<aside
  #sidebar
  [ngClass]="{ open: isOpen }"
  id="notification-sidebar"
  class="notification-sidebar d-none d-sm-none d-md-block"
>
  <!-- <a class="notification-sidebar-close" (click)="onClose()">
    <i class="ft-x font-medium-3"></i>
  </a> -->
  <div class="side-nav notification-sidebar-content" [perfectScrollbar]>
    <div class="row">
      <div class="col-12 mt-1">
        <ngb-tabset>
          <ngb-tab *ngIf="tabs.includes(notifications.TOS)">
            <ng-template ngbTabTitle><b>Terms of Service</b></ng-template>
            <ng-template ngbTabContent>
              <app-tos-update
                (toggle)="toggleNotification($event, notifications.TOS)"
              ></app-tos-update>
            </ng-template>
          </ngb-tab>
          <ngb-tab *ngIf="tabs.includes(notifications.Cookies)">
            <ng-template ngbTabTitle><b>Cookies</b></ng-template>
            <ng-template ngbTabContent>
              <app-cookie-notice
                (toggle)="toggleNotification($event, notifications.Cookies)"
              ></app-cookie-notice>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</aside>
